export enum DialogType {
  NONE = 'none',
  ALERT = 'alert',
  ERROR = 'error',
  CONFIRM = 'confirm',
  LOADING = 'loading',
}